const getUniqueCategoriesAndDescriptors = comparisonDocuments => {
    const allCategories = [];
    const allDescriptors = [];
    comparisonDocuments.forEach(doc => {
        doc.classifications.forEach(classification => {
            allCategories.push(classification.name.split(':')[0]);
            allDescriptors.push(classification.name.split(':')[1].trim());
        });
    });
    return {
        categories: [...new Set(allCategories)],
        descriptors: [...new Set(allDescriptors)],
    };
};
export default getUniqueCategoriesAndDescriptors;
